import type { CollectionPermissions } from 'pages/partners/pages/collections';
import type { FeatureFlagPermissions } from 'pages/account/feature_flag';
import type { LicensePermissions } from 'pages/licenses/license_search';
import type { SKUManagementPermissions } from 'pages/sku_management';
import type { TransactionPermissions } from 'pages/access_codes';
import type { PartnerPermissions } from 'pages/partners';
import type { StudentPermissions } from 'pages/students';
import type { ReportPermissions } from 'pages/reports';
import type { GroupPermissions } from 'pages/groups';
import type { UserPermissions } from 'pages/users';
import { ApiCaller } from 'apis/ApiCaller';

type PermissionPageMap = {
    AccessCode: TransactionPermissions;
    Collection: CollectionPermissions;
    FeatureFlag: FeatureFlagPermissions;
    FeatureRing: StudentPermissions;
    Group: GroupPermissions;
    LicenseSearch: LicensePermissions;
    Partner: PartnerPermissions;
    Report: ReportPermissions;
    SKUManagement: SKUManagementPermissions;
    Student: StudentPermissions;
    User: UserPermissions;
};

export type PermissionPage = keyof PermissionPageMap;

export class PermissionsApi {

    private static apiCaller = new ApiCaller('Permissions');

    public static Get<P extends PermissionPage>(page: P): Promise<PermissionPageMap[P]> {

        return this.apiCaller.GET(`Get${page}Permissions`);

    }

}
